import './PurchaseCard.css';

function PurchaseCard({
    title = 'Get access to all STEAM Lab video lessons',
    description = 'Unlock all STEAM Lab video lessons & resources by purchasing a membership.',
    buttonText = 'Purchase Membership',
    paymentLink = 'https://buy.stripe.com/3cIcMX3TheCFe8o6v68EM00',
    price = '$49.99',
    product = 'STEAM Lab Video Access',
    className = '',
}) {
    return (
        <div className={`purchase-card ${className}`}>
            <div className="purchase-card__content">
                <h2 className="purchase-card__title">{title}</h2>
                <div className="purchase-card__productprice-row">
                    <span className="purchase-card__productprice">
                        {product}
                        {' '}
                        <span className="purchase-card__price">{price}</span>
                    </span>
                </div>
                <p className="purchase-card__desc">{description}</p>
                <div className="purchase-card__button-row">
                    <a
                        href={paymentLink}
                        rel="noopener noreferrer"
                        className="purchase-card__button">
                        {buttonText}
                    </a>
                </div>
            </div>
        </div>
    );
}

export default PurchaseCard;
